/* eslint-disable no-unused-vars */
import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import Tabs from '../Tabs';
import Companies from './Companies';
import CompanyTags from './CompanyTags';
import classes from './styles.module.scss';
import CandidateTags from './CandidateTags';

export default function CompanyManagement() {
  const [companyCount, setCompanyCount] = useState(0);
  const [tagsCount, setTagsCount] = useState(0);
  const [candidateTagsCount, setCandidateTagsCount] = useState(0);
  const { t } = useTranslation();

  const [currentTab, setCurrentTab] = useState(
    t('dashboardComponents.Console.CompanyManagement.Companies')
  );
  const tabs = [
    t('dashboardComponents.Console.CompanyManagement.Companies'),
    t('dashboardComponents.Console.CompanyManagement.Tags'),
    t('dashboardComponents.Console.CompanyManagement.CandidateTagsTitle'),
  ];

  return (
    <div className={classes.CompanyManagement}>
      <Tabs
        currentTab={currentTab}
        setCurrentTab={setCurrentTab}
        name="companyManagement"
        tabs={tabs}
        countData={{
          [t('dashboardComponents.Console.CompanyManagement.Companies')]:
            companyCount,

          [t('dashboardComponents.Console.CompanyManagement.Tags')]: tagsCount,
          [t(
            'dashboardComponents.Console.CompanyManagement.CandidateTagsTitle'
          )]: candidateTagsCount,
        }}
      />

      <div className={classes.container}>
        <div
          style={{
            display:
              currentTab ===
              t('dashboardComponents.Console.CompanyManagement.Companies')
                ? 'block'
                : 'none',
          }}
        >
          <Companies setItemCount={setCompanyCount} />
        </div>
        <div
          style={{
            display:
              currentTab ===
              t('dashboardComponents.Console.CompanyManagement.Tags')
                ? 'block'
                : 'none',
          }}
        >
          <CompanyTags setItemCount={setTagsCount} />
        </div>
        <div
          style={{
            display:
              currentTab ===
              t(
                'dashboardComponents.Console.CompanyManagement.CandidateTagsTitle'
              )
                ? 'block'
                : 'none',
          }}
        >
          <CandidateTags setItemCount={setCandidateTagsCount} />
        </div>
      </div>
    </div>
  );
}
